@if (hasStepClickSubscribers && (processStep$ | async); as processStep) {
    <div class="step-link"
         (click)="stepClick.emit(processStep)">
        <div *ngTemplateOutlet="linkContent"></div>
    </div>
} @else {
    @if (openOnNewPage) {
        @if (stepHref$ | async; as stepHref) {
            <a [href]="stepHref.url"
               target="_blank"
               class="step-link">
                <div *ngTemplateOutlet="linkContent"></div>
            </a>
        }
    } @else {
        @if (stepHref$ | async; as stepHref) {
            <a [routerLink]="stepHref.path"
               [queryParams]="stepHref.queryParams"
               class="step-link">
                <div *ngTemplateOutlet="linkContent"></div>
            </a>
        }
    }
}
<ng-template #linkContent>
    <span class="fa-stack me-1">
        <i class="fas fa-circle fa-stack-2x"
           [ngClass]="typeClass$ | async"></i>
        @if (name$ | async) {
            <i class="fal fa-stack-1x fa-inverse"
               [ngClass]="iconClass$ | async"
               aria-hidden="true"></i>
        } @else {
            <i class="fal fa-stack-1x fa-spinner fa-spin fa-inverse"
               aria-hidden="true"></i>
        }
    </span>
    <span class="step-name">{{ name$ | async }}</span>
</ng-template>
